import {io, Socket} from 'socket.io-client'
import {SOCKET_URL, getAdminToken} from './api'

// Single shared connection to the backend '/admin' Socket.io namespace, used by
// the live activity feed. The admin JWT is passed in the handshake auth; the
// server drops the socket if it isn't a valid admin token.
let socket: Socket | null = null

export function getAdminSocket(): Socket {
  if (socket) return socket
  socket = io(`${SOCKET_URL}/admin`, {
    transports: ['websocket'],
    auth: {token: getAdminToken() ?? ''},
    autoConnect: true,
  })
  return socket
}

export function disconnectAdminSocket(): void {
  socket?.disconnect()
  socket = null
}
